import { render, staticRenderFns } from "./AdvisorLandingPage.vue?vue&type=template&id=d52db8ec&scoped=true&"
import script from "./AdvisorLandingPage.vue?vue&type=script&lang=ts&"
export * from "./AdvisorLandingPage.vue?vue&type=script&lang=ts&"
import style0 from "./AdvisorLandingPage.vue?vue&type=style&index=0&id=d52db8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52db8ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VHover,VImg,VRow,VSpacer})
